import { render, staticRenderFns } from "./Booklist.vue?vue&type=template&id=64542306&scoped=true"
import script from "./Booklist.vue?vue&type=script&lang=js"
export * from "./Booklist.vue?vue&type=script&lang=js"
import style0 from "./Booklist.vue?vue&type=style&index=0&id=64542306&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64542306",
  null
  
)

export default component.exports